<template>
  <nav v-if="items.length > 0" class="seo-breadcrumbs" aria-label="Хлебные крошки">
    <ol class="seo-breadcrumbs__list">
      <li v-for="(item, index) in items" :key="item.path || item.name" class="seo-breadcrumbs__item">
        <NuxtLink
          v-if="item.path && index < items.length - 1"
          :to="item.path"
          class="seo-breadcrumbs__link"
        >
          {{ item.name }}
        </NuxtLink>
        <!-- Последний элемент — текущая страница: ссылка на саму себя ничего не
             добавляет ни гостю, ни роботу. aria-current сообщает читалке, где мы. -->
        <span v-else class="seo-breadcrumbs__current" aria-current="page">{{ item.name }}</span>

        <span v-if="index < items.length - 1" class="seo-breadcrumbs__separator" aria-hidden="true">/</span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
/**
 * Видимые хлебные крошки.
 *
 * Разметка BreadcrumbList (useBreadcrumbsJsonLd) ставится отдельно и по тем же
 * данным. Одну без другой делать не стоит: Google рисует крошки в сниппете по
 * разметке, но требует, чтобы путь был виден и на самой странице.
 */
import type { BreadcrumbItem } from '@entities/institution';

defineProps<{ items: BreadcrumbItem[] }>();
</script>

<style scoped lang="scss">
.seo-breadcrumbs {
  @apply pt-4 md:pt-6;

  &__list {
    @apply flex flex-wrap items-center gap-x-2 gap-y-1 text-sm;
  }

  &__item {
    @apply flex items-center gap-x-2;
  }

  &__link {
    @apply no-underline text-gray-500 dark:text-gray-400 transition-colors;
    @apply hover:text-gray-900 dark:hover:text-white;
  }

  &__current {
    @apply text-gray-700 dark:text-gray-200;
  }

  &__separator {
    @apply text-gray-300 dark:text-gray-600;
  }
}
</style>
